<script setup>
import { ref } from 'vue'

const props = defineProps({
	id: {
		type: Number,
		required: true,
	},
})

const emit = defineEmits([
	'file-deleted'
])

const deleteButton = ref(null)

function deleteFile() {
    deleteButton.value.waitFor(
        axios.delete(`/api/files/${props.id.value}`)
        .then(response => {
			emit('file-deleted', props.id.value)
		})
    )
}

</script>

<template>
	<PromiseButton
		v-bind="$attrs"
		variant="link"
		color="red"
		ref="deleteButton"
		@click="deleteFile"
	>
		Delete
	</PromiseButton>
</template>